import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'policy_exceptions'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: { label: 'Inmuebles' },
  USER: {},
  STATUS: null,
  REGION: { column: 'regions.name', label: 'Estado' },
  MUNICIPALITY: { column: 'municipalities.name', label: 'Municipio' },
  SECTOR: { column: 'sectors.name', label: 'Región' },
  CENTER: false,
  TENANT: false,
})

export default {
  key: DATASET_KEY,
  label: 'Excepción de políticas',
  timeColumn: 'policy_exceptions.created_at',
  permission: { action: 'read', subject: 'PolicyException' },

  tables: {
    policy_exceptions: ["id", "reference_number", "scope_type_id", "status_id", "request_type_id", "source_id", "inherent_risk_id", "exception_type_id", "residual_risk_id", "regulatory_required", "regulation_description", "description", "compensatory_measures", "justification", "approver_soeid", "section_detail", "section_attachments", "comments", "attachments", "request_date", "start_date", "end_date", "created_by", "assigned_to", "reviewed_by", "approved_by", "created_at", "updated_at", "deleted_at"],
    policy_exception_units: ["id", "policy_exception_id", "unit_id", "created_at", "updated_at"],
    policy_exception_type_catalog: ["id", "name", "created_at", "updated_at"],
    policy_exception_status_history: ["id", "policy_exception_id", "previous_status_id", "new_status_id", "changed_by", "changed_at", "comments", "created_at", "updated_at"],
    policy_exception_status_catalog: ["id", "name", "created_at", "updated_at"],
    policy_exception_standards: ["id", "policy_exception_id", "standard_id", "section_detail", "created_at", "updated_at"],
    policy_exception_source_catalog: ["id", "name", "created_at", "updated_at"],
    policy_exception_scope_type_catalog: ["id", "name", "created_at", "updated_at"],
    policy_exception_residual_risk_catalog: ["id", "name", "created_at", "updated_at"],
    policy_exception_request_type_catalog: ["id", "name", "created_at", "updated_at"],
    policy_exception_regions: ["id", "policy_exception_id", "id_sector", "created_at", "updated_at"],
    policy_exception_notifications: ["id", "policy_exception_id", "notification_type_id", "scheduled_at", "sent_at", "status", "created_at", "updated_at"],
    policy_exception_notification_type_catalog: ["id", "name", "created_at", "updated_at"],
    policy_exception_inherent_risk_catalog: ["id", "name", "created_at", "updated_at"],
    standards: ["id", "code", "name", "is_active", "created_at", "updated_at"],
    users: ["id", "id_unit", "id_maintenance_company", "image", "check_alarms", "frame_color", "id_profile", "user", "email", "password", "name", "first_name", "second_name", "config", "plate_number", "created", "updated", "active", "vpn_access", "allow_virtual_button_alarm", "allow_visual_notifications", "allowed_units_live_video_flows", "phone_number", "alarm_history_per_hours", "alarm_history_per_days", "alarm_history_by_records", "last_login", "video_wall", "active_sesion_video_wall", "id_country", "auth_two_factor_code", "auth_two_factor_time", "auth_two_factor_type", "verify_email_code", "verify_sms_code", "verify_sms", "verify_email", "online", "enabled_chat", "enabled_helpdesk"],
    units: ["id", "id_router", "description", "address_1", "address_2", "exterior_number", "suburb", "number", "postal_code", "id_country", "id_region", "id_sector", "active", "route", "plate_number", "vin", "driver", "provider", "owner", "company", "vehicle", "allow_virtual_button_alarm", "reaction_patrol", "id_alarms_levels", "active_digital_output", "needs_check", "id_municipality", "time_zone", "data", "comments", "id_category", "id_seproban", "rems", "sirh", "created_at", "updated_at"],
    regions: ["id", "name", "code", "country_id", "acronym", "created_at", "updated_at"],
    sectors: ["id", "id_center", "name", "alcaldia", "provider", "created", "updated"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'units.description',
  },

  csvConfig: {
    withTables: 'policy_exceptions',
    columns: 'policy_exceptions.reference_number,policy_exceptions.regulatory_required,policy_exceptions.regulation_description,policy_exceptions.description,policy_exceptions.compensatory_measures,policy_exceptions.justification,policy_exceptions.approver_soeid,policy_exceptions.section_detail,policy_exceptions.section_attachments,policy_exceptions.comments,policy_exceptions.attachments,policy_exceptions.request_date,policy_exceptions.start_date,policy_exceptions.end_date,policy_exceptions.created_at,policy_exceptions.updated_at,policy_exceptions.deleted_at,policy_exception_units.created_at,policy_exception_units.updated_at,policy_exception_type_catalog.name,policy_exception_type_catalog.created_at,policy_exception_type_catalog.updated_at,policy_exception_status_history.changed_at,policy_exception_status_history.comments,policy_exception_status_history.created_at,policy_exception_status_history.updated_at,policy_exception_standards.section_detail,policy_exception_standards.created_at,policy_exception_standards.updated_at,policy_exception_source_catalog.name,policy_exception_source_catalog.created_at,policy_exception_source_catalog.updated_at,policy_exception_scope_type_catalog.name,policy_exception_scope_type_catalog.created_at,policy_exception_scope_type_catalog.updated_at,policy_exception_residual_risk_catalog.name,policy_exception_residual_risk_catalog.created_at,policy_exception_residual_risk_catalog.updated_at,policy_exception_request_type_catalog.name,policy_exception_request_type_catalog.created_at,policy_exception_request_type_catalog.updated_at,policy_exception_regions.created_at,policy_exception_regions.updated_at,policy_exception_notifications.scheduled_at,policy_exception_notifications.sent_at,policy_exception_notifications.status,policy_exception_notifications.created_at,policy_exception_notifications.updated_at,policy_exception_notification_type_catalog.name,policy_exception_notification_type_catalog.created_at,policy_exception_notification_type_catalog.updated_at,policy_exception_inherent_risk_catalog.name,policy_exception_inherent_risk_catalog.created_at,policy_exception_inherent_risk_catalog.updated_at,standards.code,standards.name,standards.is_active,standards.created_at,standards.updated_at,users.user,users.name,users.email,units.description,units.active,municipalities.name,sectors.name,regions.name',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'units.description', label: 'Inmuebles' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'regions.name', label: 'Estado' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'policy_exception_scope_type_catalog.name', label: 'Tipo de alcance' },
    { key: 'users.user', label: 'Usuario' },
    { key: 'users.name', label: 'Nombre usuario' },
    { key: 'users.id_profile', label: 'Perfil' },
    { key: 'users.email', label: 'Email usuario' },
    { key: 'policy_exception_request_type_catalog.name', label: 'Tipo de solicitud' },
    { key: 'policy_exception_type_catalog.name', label: 'Tipo de excepción' },
    { key: 'policy_exception_residual_risk_catalog.name', label: 'Riesgo residual' },
    { key: 'policy_exception_inherent_risk_catalog.name', label: 'Riesgo inherente' },
    { key: 'policy_exception_source_catalog.name', label: 'Origen' },
    { key: 'policy_exception_status_catalog.name', label: 'Estatus' },
    { key: 'standards.code', label: 'Código estándar' },
    { key: 'standards.name', label: 'Nombre estándar' },
    { key: 'policy_exceptions.request_date', label: 'Fecha de solicitud', defaultParams: { freq: '1mo' } },
    { key: 'policy_exceptions.start_date', label: 'Fecha de inicio', defaultParams: { freq: '1mo' } },
    { key: 'policy_exceptions.end_date', label: 'Fecha fin', defaultParams: { freq: '1mo' } },
    { key: 'policy_exceptions.regulatory_required', label: 'Requisito regulatorio' },
    { key: 'policy_exceptions.regulation_description', label: 'Descripción de regulación' },
    { key: 'policy_exceptions.approver_soeid', label: 'SOEID aprobador' },
    { key: 'policy_exceptions.comments', label: 'Comentarios' },
    { key: 'policy_exceptions.created_at', label: 'Fecha de creación', defaultParams: { freq: '1mo' } },
    { key: 'policy_exceptions.updated_at', label: 'Fecha de actualización', defaultParams: { freq: '1mo' } },
    { key: 'policy_exceptions.deleted_at', label: 'Fecha de eliminación', defaultParams: { freq: '1mo' } },
    { key: 'policy_exception_notifications.scheduled_at', label: 'Fecha programada (Notificación)', defaultParams: { freq: '1mo' } },
    { key: 'policy_exception_notifications.sent_at', label: 'Fecha enviada (Notificación)', defaultParams: { freq: '1mo' } },
    { key: 'policy_exception_notification_type_catalog.name', label: 'Tipo de notificación' },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'policy_exception_scope_type_catalog.name', 'Tipo de alcance', 'scope'),
    embedFilter(DATASET_KEY, 'policy_exception_request_type_catalog.name', 'Tipo de solicitud', 'request_type'),
    embedFilter(DATASET_KEY, 'policy_exception_type_catalog.name', 'Tipo de excepción', 'type'),
    embedFilter(DATASET_KEY, 'policy_exception_residual_risk_catalog.name', 'Riesgo residual', 'residual_risk'),
    embedFilter(DATASET_KEY, 'policy_exception_inherent_risk_catalog.name', 'Riesgo inherente', 'inherent_risk'),
    embedFilter(DATASET_KEY, 'policy_exception_source_catalog.name', 'Origen', 'source'),
    embedFilter(DATASET_KEY, 'standards.code', 'Código estándar', 'standard_code'),
    embedFilter(DATASET_KEY, 'standards.name', 'Nombre estándar', 'standard_name'),
    embedFilter(DATASET_KEY, 'policy_exceptions.regulatory_required', 'Requisito regulatorio', 'regulatory_required'),
    embedFilter(DATASET_KEY, 'users.user', 'Usuario', 'user_username'),
    embedFilter(DATASET_KEY, 'users.name', 'Nombre usuario', 'user_name'),
    embedFilter(DATASET_KEY, 'policy_exceptions.approver_soeid', 'SOEID aprobador', 'approver'),
    embedFilter(DATASET_KEY, 'policy_exception_notifications.status', 'Estado (Notificación)', 'notification_status'),
    embedFilter(DATASET_KEY, 'policy_exception_notification_type_catalog.name', 'Tipo de notificación', 'notification_type'),
    embedFilter(DATASET_KEY, 'users.email', 'Email usuario', 'user_email'),
    {
      key: 'request_date',
      label: 'Fecha de solicitud',
      filterType: 'where-date',
      whereColumn: 'policy_exceptions.request_date',
      defaultDays: 30,
      optionsConfig: { type: 'date' },
    },
    {
      key: 'start_date',
      label: 'Fecha de inicio',
      filterType: 'where-date',
      whereColumn: 'policy_exceptions.start_date',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'end_date',
      label: 'Fecha fin',
      filterType: 'where-date',
      whereColumn: 'policy_exceptions.end_date',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'policy_exceptions_updated_at',
      label: 'Fecha de actualización',
      filterType: 'where-date',
      whereColumn: 'policy_exceptions.updated_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'exception_deleted_at',
      label: 'Fecha de eliminación',
      filterType: 'where-date',
      whereColumn: 'policy_exceptions.deleted_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'notification_scheduled_at',
      label: 'Fecha programada (Notificación)',
      filterType: 'where-date',
      whereColumn: 'policy_exception_notifications.scheduled_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'notification_sent_at',
      label: 'Fecha enviada (Notificación)',
      filterType: 'where-date',
      whereColumn: 'policy_exception_notifications.sent_at',
      optionsConfig: { type: 'date' },
    },
  ],

  dateGrouping: {
    column: 'policy_exceptions.request_date',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
